import React, { useMemo } from "react";

const Bubbles = ({ count = 16 }) => {
  const bubbles = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => {
        const size = 6 + Math.random() * 16;
        return {
          id: i,
          left: `${Math.random() * 100}%`,
          size: `${size.toFixed(3)}px`,
          duration: `${(14 + Math.random() * 20).toFixed(3)}s`,
          delay: `${(-Math.random() * 22).toFixed(3)}s`,
        };
      }),
    [count]
  );

  return (
    <div className="pointer-events-none fixed inset-0 overflow-hidden z-0" aria-hidden="true">
      {bubbles.map((b) => (
        <span
          key={b.id}
          className="bubble"
          style={{
            left: b.left,
            width: b.size,
            height: b.size,
            animationDuration: b.duration,
            animationDelay: b.delay,
          }}
        />
      ))}
    </div>
  );
};

export default Bubbles;
